import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from './modal.component';
import { IModalConfig } from './modal.config';

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    constructor(
        private dialog: MatDialog
    ) {}

    show(config: IModalConfig): MatDialogRef<any> {
        return this.dialog.open(
            ModalComponent,
            {
                minWidth: config.minWidth ? config.minWidth : '1200px',
                disableClose: true,
                data: {
                    headerTitle: config.headerTitle ? config.headerTitle : '',
                    component: config.component ? config.component : null,
                    componentData: config.componentData ? config.componentData : null
                }
            }
        );
    }

    closeAll(){
        this.dialog.closeAll();
    }

}
